/**
 * Every rebindable key, by what it does. Values are KeyboardEvent.code
 * strings; an action fires on any of its keys. The settings panel edits
 * these, and Input reads them.
 */
export type Action =
  | "left"
  | "right"
  | "up"
  | "down"
  | "turnLeft"
  | "turnRight"
  | "inventory"
  | "camera"
  | "mute"
  | "respawn"
  | "undo"
  | "rotate"
  | "hook"
  | "eat"
  | "photo"
  | "settings";

export const DEFAULT_KEYS: Record<Action, string[]> = {
  left: ["KeyA", "ArrowLeft"],
  right: ["KeyD", "ArrowRight"],
  up: ["KeyW", "ArrowUp"],
  down: ["KeyS", "ArrowDown"],
  turnLeft: ["KeyQ"],
  turnRight: ["KeyE"],
  inventory: ["KeyI"],
  camera: ["KeyV"],
  mute: ["KeyM"],
  respawn: ["KeyR"],
  undo: ["KeyZ"],
  rotate: ["KeyT"],
  hook: ["KeyG"],
  eat: ["KeyH"],
  photo: ["KeyP"],
  settings: ["KeyO"],
};

/** What each action is called in the settings panel. */
export const ACTION_NAMES: Record<Action, string> = {
  left: "Walk left / back up",
  right: "Walk right / go forward",
  up: "Jump, climb, rise; hold in the air to fly on a steampack",
  down: "Climb down, sink",
  turnLeft: "Turn counter-clockwise (the ship at the helm; yourself in open space)",
  turnRight: "Turn clockwise (the ship at the helm; yourself in open space)",
  inventory: "Inventory and crafting",
  camera: "Camera turns / world-up",
  mute: "Sound on / off",
  respawn: "Start over (your bed, or a rock at the start)",
  undo: "Undo last block (with Ctrl)",
  rotate: "Rotate what you're placing",
  hook: "Let go of (or grab) a vine; at the helm, fire or release the ship's grapple",
  eat: "Eat (heal)",
  photo: "Photo mode",
  settings: "Settings",
};

/** A key code as a short label: "KeyA" -> "A", "ArrowLeft" -> "←". */
export function keyLabel(code: string): string {
  const arrows: Record<string, string> = { ArrowLeft: "←", ArrowRight: "→", ArrowUp: "↑", ArrowDown: "↓" };
  if (arrows[code]) return arrows[code]!;
  if (code.startsWith("Key")) return code.slice(3);
  if (code.startsWith("Digit")) return code.slice(5);
  return code.replace(/Left$|Right$/, "");
}
